import React, { Component } from 'react';
import { unmountComponentAtNode } from 'react-dom';
import Welcome from '../partials/Welcome';
import Location from '../partials/Location';
import Introduction from '../partials/Introduction';
import ContactHome from '../pages/ContactHome';
import Fade from 'react-reveal/Fade';
import Residences from '../partials/Residences';
import '../Footer';
import '../Header';
import '../../assets/css/Header.css';
import '../../assets/css/footer.css';
import '../../assets/css/Menu.css';

/* document.getElementById("header").style.visibility="hidden";
document.getElementById("footer").style.visibility="hidden"; */

export default class Home extends Component {
  render() {
    window.onload = function() {
      
    }


    return (
      <div className='main'>
        <Fade>
          <Welcome />
        </Fade>
        <Introduction />
        <Residences />
        {/* <Fade top duration={500}>
          <Location />
        </Fade> */}
        {/* <Fade top duration={500}> */}
        <ContactHome />
        {/* </Fade> */}
      </div>
    )
  }

}
